'use client';

enum SpeculationRuleTypes {
  type = 'speculationrules',
}

export function addSpeculationRule(enrollmentUrl: string): (() => void) | undefined {
  if (typeof window === 'undefined') return undefined;

  const speculationScript = document.createElement('script');
  speculationScript.type = SpeculationRuleTypes.type;
  speculationScript.textContent = JSON.stringify({
    prefetch: [{ urls: [enrollmentUrl], referrer_policy: 'strict-origin-when-cross-origin' }],
  });
  document.body?.append(speculationScript);

  return () => speculationScript.remove();
}
